import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import { loginEvent } from "./loginUtils";
export const useLoginForm = () => {
    const { createKlaviyoEvent, gaEvent } = useLogging();
    return {
        loginEvent: loginEvent(createKlaviyoEvent, gaEvent),
    };
};
